export default "__VITE_ASSET__DMG8O32N__"